import { apiPath } from "@/api/api-path"
import axios from "axios"
import qs from "qs"
import store from "@/store/index"
import api from "../service"

let tokenForExternal

function setTokenFromVuex() {
  tokenForExternal = store.state.appPermission.token
}

export async function getSiteAccessList(filter) {
  return api
    .get(apiPath.getSiteAccessList, {
      params: {
        ...filter,
      },
      paramsSerializer: (params) => {
        return qs.stringify(params)
      },
    })
    .then((response) => {
      if (response.status === 200) return response.data
    })
    .catch((error) => {
      console.error(error)
    })
}

export async function getSiteAccessVisitors(filterSiteId = []) {
  return api
    .get(apiPath.getSiteAccessVisitors, {
      params: {
        ...filterSiteId,
      },
      paramsSerializer: (params) => {
        return qs.stringify(params)
      },
    })
    .then((response) => {
      if (response.status === 200) return response.data
    })
    .catch((error) => {
      console.error(error)
    })
}

export async function getExternalSiteAccessList(filter) {
  setTokenFromVuex()

  return axios
    .get(apiPath.getExternalSiteAccessList, {
      headers: {
        Authorization: "Bearer " + tokenForExternal, //the token is a variable which holds the token
      },
      params: {
        ...filter,
      },
      paramsSerializer: (params) => {
        return qs.stringify(params)
      },
    })
    .then((response) => {
      if (response.status === 200) return response.data
    })
    .catch((error) => {
      console.error(error)
    })
}

export async function getExternalSiteAccessVisitors(filterSiteId = []) {
  setTokenFromVuex()

  return axios
    .get(apiPath.getExternalSiteAccessVisitors, {
      headers: {
        Authorization: "Bearer " + tokenForExternal, //the token is a variable which holds the token
      },
      params: {
        ...filterSiteId,
      },
      paramsSerializer: (params) => {
        return qs.stringify(params)
      },
    })
    .then((response) => {
      if (response.status === 200) return response.data
    })
    .catch((error) => {
      console.error(error)
    })
}

export async function getExternalSiteAccessById(id) {
  setTokenFromVuex()
  return axios
    .get(apiPath.getExternalSiteAccessById.replace("{siteAccessId}", id), {
      headers: {
        Authorization: "Bearer " + tokenForExternal,
      },
    })
    .then((response) => {
      if (response.status === 200) return response.data.data
    })
    .catch((error) => {
      console.error(error)
      throw error
    })
}

export async function updateExternalSiteAccessById(id, body) {
  setTokenFromVuex()
  return axios
    .patch(
      apiPath.updateExternalSiteAccessById.replace("{siteAccessId}", id),
      body,
      {
        headers: {
          Authorization: "Bearer " + tokenForExternal, //the token is a variable which holds the token
        },
      }
    )
    .then((response) => {
      if (response.status === 200) return response.data
    })
    .catch((error) => {
      console.error(error)

      throw error
    })
}

export async function deleteExternalSiteAccessById(id) {
  setTokenFromVuex()
  return axios
    .delete(
      apiPath.updateExternalSiteAccessById.replace("{siteAccessId}", id),
      {
        headers: {
          Authorization: "Bearer " + tokenForExternal, //the token is a variable which holds the token
        },
      }
    )
    .then((response) => {
      if (response.status === 200) return response.data
    })
    .catch((error) => {
      console.error(error)

      throw error
    })
}

export async function getSiteAccessById(id) {
  return api
    .get(apiPath.getSiteAccessById.replace("{siteAccessId}", id), {})
    .then((response) => {
      if (response.status === 200) return response.data.data
    })
    .catch((error) => {
      console.error(error)
      throw error
    })
}

export async function updateSiteAccessById(id, body) {
  return api
    .patch(apiPath.updateSiteAccessById.replace("{siteAccessId}", id), body, {})
    .then((response) => {
      if (response.status === 200) return response.data
    })
    .catch((error) => {
      console.error(error)

      throw error
    })
}

export async function deleteSiteAccessById(id) {
  return api
    .delete(apiPath.updateSiteAccessById.replace("{siteAccessId}", id), {})
    .then((response) => {
      if (response.status === 200) return response.data
    })
    .catch((error) => {
      console.error(error)

      throw error
    })
}

export async function getVisitorsById(id, isInternal = false) {
  const path = isInternal
    ? apiPath.getVisitorsById
    : apiPath.getExternalVisitorsById

  if (isInternal) {
    return api
      .get(path.replace("{siteAccessId}", id), {})
      .then((response) => {
        if (response.status === 200) return response.data.data
      })
      .catch((error) => {
        console.error(error)
      })
  } else {
    setTokenFromVuex()
    return axios
      .get(path.replace("{siteAccessId}", id), {
        headers: {
          Authorization: "Bearer " + tokenForExternal,
        },
      })
      .then((response) => {
        if (response.status === 200) return response.data.data
      })
      .catch((error) => {
        console.error(error)
      })
  }
}

export async function createNewSiteAccess(request, isInternal = false) {
  if (isInternal) {
    return api
      .post(apiPath.createNewSiteAccess, request, {})
      .then((response) => {
        if (response.status === 200) return response.data
      })
      .catch((error) => {
        throw error
        console.error(error)
      })
  } else {
    setTokenFromVuex()
    return axios
      .post(apiPath.createExternalSiteAccess, request, {
        headers: {
          Authorization: "Bearer " + tokenForExternal,
        },
      })
      .then((response) => {
        if (response.status === 200) return response.data
      })
      .catch((error) => {
        throw error
        console.error(error)
      })
  }
}

export async function getTodaySiteAccessStatus(filter) {
  return api
    .get(apiPath.getTodaySiteAccessStatus, {
      params: {
        ...filter,
      },
      paramsSerializer: (params) => {
        return qs.stringify(params)
      },
    })
    .then((response) => {
      if (response.status === 200) return response.data
    })
    .catch((error) => {
      console.error(error)
    })
}

export async function getTodayStatusCount(filter) {
  return api
    .get(apiPath.getTodayStatusCount, {
      params: {
        ...filter,
      },
      paramsSerializer: (params) => {
        return qs.stringify(params)
      },
    })
    .then((response) => {
      if (response.status === 200) return response.data
    })
    .catch((error) => {
      console.error(error)
    })
}

export async function getTodaySelfCheckIn(filter) {
  return api
    .get(apiPath.getTodaySelfCheckIn, {
      params: {
        ...filter,
      },
      paramsSerializer: (params) => {
        return qs.stringify(params)
      },
    })
    .then((response) => {
      if (response.status === 200) return response.data
    })
    .catch((error) => {
      console.error(error)
    })
}

export async function getTodaySiteApproved(filter) {
  return api
    .get(apiPath.getTodaySiteApproved, {
      params: {
        ...filter,
      },
      paramsSerializer: (params) => {
        return qs.stringify(params)
      },
    })
    .then((response) => {
      if (response.status === 200) return response.data
    })
    .catch((error) => {
      console.error(error)
    })
}

export async function getTodaySiteAccess(filter) {
  return api
    .get(apiPath.getTodaySiteAccess, {
      params: {
        ...filter,
      },
      paramsSerializer: (params) => {
        return qs.stringify(params)
      },
    })
    .then((response) => {
      if (response.status === 200) return response.data
    })
    .catch((error) => {
      console.error(error)
    })
}

export async function getPastSiteAccess(filter) {
  return api
    .get(apiPath.getPastSiteAccess, {
      params: {
        ...filter,
      },
      paramsSerializer: (params) => {
        return qs.stringify(params)
      },
    })
    .then((response) => {
      if (response.status === 200) return response.data
    })
    .catch((error) => {
      console.error(error)
    })
}

export async function updateSiteAccessStatusById(id, body) {
  return api
    .put(
      apiPath.updateSiteAccessStatusById.replace("{siteAccessId}", id),
      body,
      {}
    )
    .then((response) => {
      if (response.status === 200) return response.data
    })
    .catch((error) => {
      console.error(error)

      throw error
    })
}

export async function addExternalAttachmentById(siteAccessId, body) {
  setTokenFromVuex()
  return axios
    .post(
      apiPath.addExternalAttachmentById.replace("{siteAccessId}", siteAccessId),
      body,
      {
        headers: {
          Authorization: "Bearer " + tokenForExternal, //the token is a variable which holds the token
        },
      }
    )
    .then((response) => {
      if (response.status === 200) return response.data
    })
    .catch((error) => {
      console.error(error)
      throw error
    })
}

export async function editExternalAttachmentById(
  siteAccessId,
  attachmentId,
  body
) {
  setTokenFromVuex()
  return axios
    .put(
      apiPath.editExternalAttachmentById
        .replace("{siteAccessId}", siteAccessId)
        .replace("{attachmentId}", attachmentId),
      body,
      {
        headers: {
          Authorization: "Bearer " + tokenForExternal, //the token is a variable which holds the token
        },
      }
    )
    .then((response) => {
      if (response.status === 200) return response.data
    })
    .catch((error) => {
      console.error(error)
      throw error
    })
}

export async function deleteExternalAttachmentById(siteAccessId, attachmentId) {
  setTokenFromVuex()
  return axios
    .delete(
      apiPath.deleteExternalAttachmentById
        .replace("{siteAccessId}", siteAccessId)
        .replace("{attachmentId}", attachmentId),
      {
        headers: {
          Authorization: "Bearer " + tokenForExternal, //the token is a variable which holds the token
        },
      }
    )
    .then((response) => {
      if (response.status === 200) return response.data
    })
    .catch((error) => {
      console.error(error)
      throw error
    })
}

export async function addAttachmentById(siteAccessId, body) {
  return api
    .post(
      apiPath.addAttachmentById.replace("{siteAccessId}", siteAccessId),
      body,
      {}
    )
    .then((response) => {
      if (response.status === 200) return response.data
    })
    .catch((error) => {
      console.error(error)
      throw error
    })
}

export async function editAttachmentById(siteAccessId, attachmentId, body) {
  return api
    .put(
      apiPath.editAttachmentById
        .replace("{siteAccessId}", siteAccessId)
        .replace("{attachmentId}", attachmentId),
      body,
      {}
    )
    .then((response) => {
      if (response.status === 200) return response.data
    })
    .catch((error) => {
      console.error(error)
      throw error
    })
}

export async function deleteAttachmentById(siteAccessId, attachmentId) {
  return api
    .delete(
      apiPath.deleteAttachmentById
        .replace("{siteAccessId}", siteAccessId)
        .replace("{attachmentId}", attachmentId),
      {}
    )
    .then((response) => {
      if (response.status === 200) return response.data
    })
    .catch((error) => {
      console.error(error)
      throw error
    })
}

export async function resendEmailSiteAccess(body) {
  return api
    .post(apiPath.resendEmail, body, {})
    .then((response) => {
      if (response.status === 201) return response.data.data
    })
    .catch((error) => {
      throw error
    })
}
